import React from 'react';
import classNames from 'classnames';
import { Button, Loading } from 'glints-aries';
import PropTypes from 'prop-types';

import styles from './AriesButtons.scss';

const BtnWhiteBordered = ({ className, loading, small, ...props }) => (
  <Button
    variant="ghost"
    style={
      small
        ? { lineHeight: 1, padding: '5px 12px' }
        : { lineHeight: 1, padding: '15px 40px' }
    }
    className={classNames(small ? styles.btnSmall : styles.btn, className)}
    {...props}
  >
    {props.children}
    <If condition={loading}>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <Loading className={styles.loading} />
    </If>
  </Button>
);

BtnWhiteBordered.propTypes = {
  loading: PropTypes.bool,
  small: PropTypes.bool,

  children: PropTypes.node,

  props: PropTypes.object,

  className: PropTypes.string,
};

export default BtnWhiteBordered;
